/**
 * Sortable ticket list for Rapid Fusion staff.
 */

import React from 'react';

const COLUMNS = [
  { key: 'id', label: 'ID' },
  { key: 'subject', label: 'Subject' },
  { key: 'requester', label: 'Requester' },
  { key: 'org', label: 'Organisation' },
  { key: 'audience', label: 'Who' },
  { key: 'type', label: 'Type' },
  { key: 'product', label: 'Product' },
  { key: 'status', label: 'Status' },
  { key: 'priority', label: 'Priority' },
  { key: 'assignee', label: 'Assignee' },
  { key: 'reply', label: 'First reply' },
  { key: 'updated', label: 'Updated' },
];

function named(list, id) {
  if (!id) return 'Not set';
  const found = (list || []).find((item) => item.id === id);
  return found ? found.label : id;
}

function whenLabel(iso) {
  const ms = Date.now() - Date.parse(iso);
  if (!Number.isFinite(ms) || ms < 0) return '';
  const hours = Math.floor(ms / 3600000);
  if (hours < 1) return 'under an hour';
  if (hours < 48) return `${hours} hours`;
  return `${Math.floor(hours / 24)} days`;
}

function replyLabel(item) {
  if (item.overdue) return 'Overdue';
  if (!item.firstReplyAt) return 'Waiting';
  const ms = Date.parse(item.firstReplyAt) - Date.parse(item.createdAt);
  if (!Number.isFinite(ms) || ms < 0) return 'Replied';
  const hours = Math.floor(ms / 3600000);
  if (hours < 1) return 'under an hour';
  if (hours < 48) return `${hours} hours`;
  return `${Math.floor(hours / 24)} days`;
}

export default function TicketTable({
  tickets, meta, selected, sort, dir, busy, canDelete, onToggle, onToggleAll, onOpen, onSort, onDelete,
}) {
  const allChecked = tickets.length > 0 && tickets.every((item) => selected.includes(item.id));

  function header(column) {
    const mark = sort === column.key ? (dir === 'asc' ? ' ↑' : ' ↓') : '';
    return (
      <th key={column.key}>
        <button type="button" onClick={() => onSort(column.key)}>
          {column.label}{mark}
        </button>
      </th>
    );
  }

  return (
    <div className="support-table-wrap">
      <table className="support-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                aria-label="Select all"
                checked={allChecked}
                onChange={(event) => onToggleAll(event.target.checked)}
              />
            </th>
            {COLUMNS.map(header)}
            {canDelete && <th>Delete</th>}
          </tr>
        </thead>
        <tbody>
          {tickets.length === 0 && (
            <tr>
              <td colSpan={COLUMNS.length + (canDelete ? 2 : 1)} className="support-meta">No tickets here.</td>
            </tr>
          )}
          {tickets.map((item) => (
            <tr key={item.id} className={item.overdue ? 'overdue' : ''}>
              <td>
                <input
                  type="checkbox"
                  aria-label={`Select ${item.id}`}
                  checked={selected.includes(item.id)}
                  onChange={() => onToggle(item.id)}
                />
              </td>
              <td>{item.id}</td>
              <td className="support-subject">
                <button type="button" className="support-row-open" onClick={() => onOpen(item.id)}>
                  {item.subject}
                </button>
              </td>
              <td>{item.requester?.name || item.requester?.email || ''}</td>
              <td>{item.org?.name || ''}</td>
              <td>{named(meta?.audiences, item.audience, '')}</td>
              <td>{named(meta?.types, item.type)}</td>
              <td>{named(meta?.products, item.product)}</td>
              <td>{named(meta?.statuses, item.status)}</td>
              <td>{named(meta?.priorities, item.priority)}</td>
              <td>{item.assignee?.name || 'Unassigned'}</td>
              <td>{replyLabel(item)}</td>
              <td>{whenLabel(item.updatedAt)}</td>
              {canDelete && (
                <td>
                  <button type="button" className="rf-btn rf-btn-danger" disabled={busy} onClick={() => onDelete(item)}>
                    Delete
                  </button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
